(function(){
  function reveal(){
    var els=document.querySelectorAll('.awf .rv:not(.in)');
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('in')});return;}
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}})},{threshold:.12});
    els.forEach(function(el,i){el.style.transitionDelay=(i%4*70)+'ms';io.observe(el);});
  }
  function countdown(){
    document.querySelectorAll('[data-awf-count]').forEach(function(box){
      if(box.__awf)return; box.__awf=1;
      var t=new Date(box.getAttribute('data-awf-count')).getTime();
      if(isNaN(t))return;
      var p=function(n){return ('0'+n).slice(-2)};
      function tick(){
        var d=t-Date.now(); if(d<0)d=0;
        var dd=Math.floor(d/86400000),hh=Math.floor(d%86400000/3600000),mm=Math.floor(d%3600000/60000),ss=Math.floor(d%60000/1000);
        var a=box.querySelector('[data-d]'),b=box.querySelector('[data-h]'),c=box.querySelector('[data-m]'),e=box.querySelector('[data-s]');
        if(a)a.textContent=dd; if(b)b.textContent=p(hh); if(c)c.textContent=p(mm); if(e)e.textContent=p(ss);
      }
      tick(); setInterval(tick,1000);
    });
  }
  function tabs(){
    document.querySelectorAll('[data-awf-tabs]').forEach(function(root){
      root.querySelectorAll('.tab').forEach(function(b){
        if(b.__awf)return; b.__awf=1;
        b.addEventListener('click',function(){
          root.querySelectorAll('.tab').forEach(function(x){x.classList.remove('on')});
          b.classList.add('on');
          var g=b.getAttribute('data-g');
          root.querySelectorAll('[data-group]').forEach(function(r){
            r.style.display=(r.getAttribute('data-group')===g)?(r.getAttribute('data-display')||'grid'):'none';
          });
        });
      });
    });
  }
  function faq(){
    document.querySelectorAll('.awf .q>button').forEach(function(b){
      if(b.__awf)return; b.__awf=1;
      b.addEventListener('click',function(ev){
        ev.preventDefault();
        var q=b.parentElement, a=q.querySelector('.a'), open=q.classList.contains('open');
        var scope=q.parentElement;
        scope.querySelectorAll('.q').forEach(function(x){x.classList.remove('open');var xa=x.querySelector('.a');if(xa)xa.style.maxHeight='0px';});
        if(!open){q.classList.add('open');a.style.maxHeight=a.scrollHeight+'px';}
      });
    });
  }
  function init(){reveal();countdown();tabs();faq();}
  if(document.readyState!=='loading'){init();}else{document.addEventListener('DOMContentLoaded',init);}
  document.addEventListener('shopify:section:load',init);
  window.addEventListener('resize',function(){
    document.querySelectorAll('.awf .q.open .a').forEach(function(a){a.style.maxHeight=a.scrollHeight+'px'});
  });
})();